import Child, { GenderKey } from '@/types/Child'
import Invitation from '@/types/Invitation'
import Relationship from '@/types/Relationship'
import Caregiver from '@/types/Caregiver'
import firebase from './firebase'
import moment from 'moment'
import { findRelationshipByKey, relationshipOther } from '@/constants/relationships'

import FirebaseChildren from './children'
const firebaseChildren = new FirebaseChildren()

interface InvitationDocData {
  childColor: string
  childGenderKey: GenderKey
  childId: string
  childName: string
  createdAt: firebase.firestore.FieldValue | firebase.firestore.Timestamp
  expiredAt: firebase.firestore.FieldValue | firebase.firestore.Timestamp
  createdUserId: string
}

interface InvitationDocDataIn extends InvitationDocData {
  createdAt: firebase.firestore.Timestamp
  expiredAt: firebase.firestore.Timestamp
}

export default class {
  async getInvitation(invitationId: string): Promise<Invitation | null> {
    const doc: firebase.firestore.DocumentData = await firebase.firestore().doc(`invitations/${invitationId}`).get()
    if (!doc) return null
    const data: InvitationDocDataIn = doc.data()
    const child: Child = {
      birthday: moment(),
      caregivers: [],
      color: data.childColor,
      createdAt: moment(),
      genderKey: data.childGenderKey,
      id: data.childId,
      name: data.childName,
      relationshipKey: '',
    }
    return {
      id: doc.string,
      child,
      createdUserId: data.createdUserId,
      createdAt: moment(data.createdAt.toDate()),
      expiredAt: moment(data.expiredAt.toDate()),
    }
  }

  async createInvitation(child: Child): Promise<string> {
    const expiredAtMoment = moment().clone().add(1, 'days')
    const docData: InvitationDocData = {
      childColor: child.color,
      childGenderKey: child.genderKey,
      childId: child.id,
      childName: child.name,
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      expiredAt: firebase.firestore.Timestamp.fromDate(expiredAtMoment.toDate()),
      createdUserId: this.getUserId(),
    }
    const invitationDoc = await firebase.firestore().collection('invitations').add(docData)
    return invitationDoc.id
  }

  getUserId(): string {
    const user = firebase.auth().currentUser
    if (!user) throw new Error('auth required')
    return user.uid
  }

  async applyInvitation(invitationId: string, childId: string): Promise<void> {
    await Promise.all([
      firebase.firestore().collection('invitations').doc(invitationId).delete(),
      firebaseChildren.addCaregiver(childId, relationshipOther),
    ])
  }
}
